<template>
  <div class="timepicker">
    <div class="timepicker-picker">
      <table class="table-condensed">
        <tr>
          <td>
            <a
              href="#"
              tabindex="-1"
              class="btn"
              @click.prevent="incrementHour"
            >
              <span class="glyphicon glyphicon-chevron-up"></span>
            </a>
          </td>
          <td class="separator"></td>
          <td>
            <a
              href="#"
              tabindex="-1"
              class="btn"
              @click.prevent="incrementMinute"
            >
              <span class="glyphicon glyphicon-chevron-up"></span>
            </a>
          </td>
          <td class="separator"></td>
        </tr>
        <tr>
          <td>
            <span class="timepicker-hour" @click="emitChange()">
              {{ hour }}
            </span>
          </td>
          <td class="separator">:</td>
          <td>
            <span class="timepicker-minute" @click="emitChange()">
              {{ minute }}
            </span>
          </td>
          <td>
            <button class="btn btn-primary" tabindex="-1" @click="togglePeriod">
              {{ period }}
            </button>
          </td>
        </tr>
        <tr>
          <td>
            <a
              href="#"
              tabindex="-1"
              class="btn"
              @click.prevent="decrementHour"
            >
              <span class="glyphicon glyphicon-chevron-down"></span>
            </a>
          </td>
          <td class="separator"></td>
          <td>
            <a
              href="#"
              tabindex="-1"
              class="btn"
              @click.prevent="decrementMinute"
            >
              <span class="glyphicon glyphicon-chevron-down"></span>
            </a>
          </td>
          <td class="separator"></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { sprintf } from 'sprintf-js'

export default {
  name: 'TimePicker',
  props: {
    currentDate: {
      default: () => moment()
    },
    format: {
      type: String,
      default: 'hh:mm a'
    }
  },
  data() {
    return {
      hour: this.currentDate.format('hh'),
      minute: this.currentDate.format('mm'),
      period: this.currentDate.format('A')
    }
  },
  methods: {
    togglePeriod() {
      this.period = this.period === 'AM' ? 'PM' : 'AM'

      this.emitChange()
    },
    incrementHour() {
      if (parseInt(this.hour) === 12) {
        this.hour = sprintf('%02d', 1)
      } else {
        this.hour = sprintf('%02d', parseInt(this.hour) + 1)
      }

      this.emitChange()
    },
    decrementHour() {
      if (parseInt(this.hour) === 1) {
        this.hour = sprintf('%02d', 12)
      } else {
        this.hour = sprintf('%02d', parseInt(this.hour) - 1)
      }

      this.emitChange()
    },
    incrementMinute() {
      if (parseInt(this.minute) === 59) {
        this.minute = sprintf('%02d', 0)
      } else {
        this.minute = sprintf('%02d', parseInt(this.minute) + 1)
      }

      this.emitChange()
    },
    decrementMinute() {
      if (parseInt(this.minute) === 0) {
        this.minute = sprintf('%02d', 59)
      } else {
        this.minute = sprintf('%02d', parseInt(this.minute) - 1)
      }

      this.emitChange()
    },
    emitChange() {
      this.$emit('change', `${this.hour}:${this.minute} ${this.period}`)
    }
  }
}
</script>

<style lang="scss">
.timepicker {
  color: #2d353c;
  min-width: 250px !important;
  border-radius: 6px !important;
  padding: 0 !important;

  .timepicker-picker {
    padding: 5px;
  }
}
</style>
